import { Text, View } from '@react-pdf/renderer';

import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { globalStyles } from '../../styles';
import { styles } from './styles';

interface WhoAttendsProps {
  event: PublicEventDetailsResponse;
}

export interface TargetGroupItem {
  title: string;
  icon: string;
  content: Array<{ percentage: number; title: string }>;
}
const TargetGroups = ({ event }: WhoAttendsProps) => {
  const { t } = useTranslation();

  const targetGroupsItems = useMemo(
    () =>
      event?.website_content?.targetgroups
        ?.filter(e => e)
        ?.sort((a, b) => a.order - b.order)
        ?.reduce((acc, item) => {
          if (item.level === 0) {
            acc.push({
              title: item.label,
              icon: item.icon?.split('-')?.join('_'),
              content: [],
            });
          } else if (item.level === 1 && acc.length > 0) {
            acc[acc.length - 1].content.push({
              title: item.label,
              percentage: item.value,
            });
          }
          return acc;
        }, []) as TargetGroupItem[],
    [event?.website_content?.targetgroups]
  );

  const icons = ['\uf200', '\uf290', '\uf1c1', '\uf155'];

  return (
    <View style={globalStyles.body}>
      <Text
        style={{
          ...styles.titleText,
          color: event?.design?.themeColor,
        }}
      >
        {t('who-attends')}
      </Text>
      <View
        style={{
          ...globalStyles.lineBar,
          borderColor: event?.design?.themeColor ?? 'black',
        }}
      />

      <Text style={{ ...globalStyles.regularText, fontWeight: 400 }}>
        {t('who-attends-pdf-text', { eventName: event?.name })}
      </Text>

      <Text style={{ ...styles.titleText, color: event?.design?.themeColor }}>
        {t('expected-target-groups')}
      </Text>
      <View
        style={{
          ...globalStyles.lineBar,
          borderColor: event?.design?.themeColor ?? 'black',
        }}
      />

      <View style={styles.targetGroupsWrapper}>
        {targetGroupsItems?.map((item, index) => (
          <View key={item.title}>
            <View style={styles.targetGroupsItem}>
              <View style={styles.targetGroupsHeader}>
                <Text style={styles.icon}>{icons[index]}</Text>
                <Text style={styles.columnTitle}>{item.title}</Text>
              </View>

              <View>
                {item.content.map((content, index) => (
                  <View key={index} style={{ marginBottom: 6 }}>
                    <View style={styles.rowSpaceBetween}>
                      <Text
                        style={{
                          ...styles.smallText,
                          width: '80%',
                          textAlign: 'left',
                        }}
                      >
                        {content.title}
                      </Text>
                      <Text
                        style={{
                          ...styles.smallText,
                          width: '20%',
                          textAlign: 'right',
                        }}
                      >
                        {content.percentage}%
                      </Text>
                    </View>
                    <View style={styles.progressBarContainer}>
                      <View
                        style={{
                          ...styles.progressBarFill,
                          width: `${content.percentage}%`,
                          backgroundColor: event?.design?.themeColor ?? 'black',
                        }}
                      />
                    </View>
                  </View>
                ))}
              </View>
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};

export default TargetGroups;
